import { render, staticRenderFns } from "./preview-comment.vue?vue&type=template&id=e46ecf6e&scoped=true&"
import script from "./preview-comment.vue?vue&type=script&lang=js&"
export * from "./preview-comment.vue?vue&type=script&lang=js&"
import style0 from "./preview-comment.vue?vue&type=style&index=0&id=e46ecf6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e46ecf6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VDivider,VIcon,VSpacer,VTextarea})
